import produce from 'immer';
import { AnyAction } from 'redux';
import { EXECUTION_LOG_TASKS } from '../actions/actions';

type ExecutionLog = {
  id: string;
  Status: string;
  Timestamp: string;
};

const initialState: {
  logs: { [taskId: string]: ExecutionLog[] };
  selectedLog?: string;
  logData: { [logId: string]: string };
} = {
  logs: {},
  selectedLog: undefined,
  logData: {},
};

const executionLogReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case EXECUTION_LOG_TASKS.GET_EXECUTION_LOG: {
      return produce(state, (draftState) => {
        const { id, data } = action.payload;
        if (draftState.logs[id]) draftState.logs[id].push(...data);
        else draftState.logs[id] = data;
      });
    }
    case EXECUTION_LOG_TASKS.SET_SELECTED_LOG: {
      return produce(state, (draftState) => {
        draftState.selectedLog = action.payload;
      });
    }
    case EXECUTION_LOG_TASKS.SET_LOG_DATA: {
      return produce(state, (draftState) => {
        const { id, data } = action.payload;
        draftState.logData[id] = data;
      });
    }
    default:
      return state;
  }
};

export default executionLogReducer;
